import React from 'react';
import { CiCircleMinus } from 'react-icons/ci';
import { GoIssueReopened } from 'react-icons/go';

interface DashboardReopenRowProps {
  onHoldCount: number;
  unpaidReopenCount: number;
  paidReopenCount: number;
  onStatusClick: (status: string, index: number) => void;
  loading?: boolean;
}

const DashboardReopenRow: React.FC<DashboardReopenRowProps> = ({
  onHoldCount,
  unpaidReopenCount,
  paidReopenCount,
  onStatusClick,
  loading = false,
}) => {
  if (loading) {
    return (
      <div className="mb-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="bg-white rounded-2xl border border-gray-200 p-6 shadow-sm animate-pulse">
            <div className="h-8 w-32 bg-gray-200 rounded mb-4"></div>
            <div className="h-12 w-20 bg-gray-200 rounded mb-2"></div>
          </div>
          <div className="bg-white rounded-2xl border border-gray-200 p-6 shadow-sm animate-pulse">
            <div className="h-8 w-32 bg-gray-200 rounded mb-4"></div>
            <div className="h-12 w-20 bg-gray-200 rounded mb-2"></div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="mb-10">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Projects Reopen Status - LEFT CARD */}
        <div className="w-full rounded-2xl border border-[#8ccdff] shadow-[0px_7px_16px_#6ed48526] bg-white">
          <div className="p-6">
            <div className="grid grid-cols-2 gap-6">
              {/* Unpaid Reopen */}
              <button
                onClick={() => onStatusClick('REVISION', 7)}
                className="relative cursor-pointer transition-all duration-200 hover:opacity-80 text-left"
              >
                <div className="flex flex-col gap-2">
                  <div className="flex items-center gap-2 min-w-0">
                    <div><GoIssueReopened className="w-6 h-6 flex-shrink-0 text-[#0382e2]" /></div>
                    <h3 className="font-semibold text-[#0382e2] text-sm sm:text-base lg:text-lg xl:text-xl tracking-[-0.52px] leading-normal truncate">
                      Unpaid Reopen
                    </h3>
                  </div>
                  <p className="font-extrabold text-[#0382e2] text-4xl tracking-[-0.72px] leading-normal">
                    {unpaidReopenCount.toLocaleString()}
                  </p>
                  <p className="font-normal italic text-[#59b7ff] text-sm tracking-[-0.40px] leading-normal">
                    Projects Unpaid
                  </p>
                </div>
              </button>

              {/* Vertical Separator */}
              <div className="relative">
                <div className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-3 w-[1px] h-[110px] bg-[#e5e5e5]"></div>

                {/* Paid Reopen */}
                <button
                  onClick={() => onStatusClick('REOPEN', 8)}
                  className="cursor-pointer transition-all duration-200 hover:opacity-80 text-left"
                >
                  <div className="flex flex-col gap-2">
                    <div className="flex items-center gap-2 min-w-0">
                     <div><GoIssueReopened className="w-6 h-6 flex-shrink-0 text-[#0382e2]" /></div>
                      <h3 className="font-semibold text-[#0382e2] text-sm sm:text-base lg:text-lg xl:text-xl tracking-[-0.52px] leading-normal truncate">
                        Paid Reopen
                      </h3>
                    </div>
                    <p className="font-extrabold text-[#0382e2] text-4xl tracking-[-0.72px] leading-normal">
                      {paidReopenCount.toLocaleString()}
                    </p>
                    <p className="font-normal italic text-[#59b7ff] text-sm tracking-[-0.40px] leading-normal">
                      Projects Paid
                    </p>
                  </div>
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* On-Hold Status - RIGHT CARD */}
        <button
          onClick={() => onStatusClick('HOLD', 9)}
          className="w-full rounded-2xl border border-[#bbbbbb] shadow-[0px_7px_16px_#6ed48526] bg-white cursor-pointer transition-all duration-200 hover:shadow-xl hover:-translate-y-1 text-left"
        >
          <div className="p-6 flex flex-col gap-2">
            <div className="flex items-center gap-2 min-w-0">
              <div><CiCircleMinus  className="w-6 h-6 flex-shrink-0 text-[#6c757d]" /></div>
              <div className="font-semibold text-[#6c757d] text-sm sm:text-base lg:text-lg xl:text-xl tracking-[-0.52px] leading-normal truncate">
                On-Hold
              </div>
            </div>

            <div className="font-extrabold text-[#6c757d] text-4xl tracking-[-0.72px] leading-normal">
              {onHoldCount.toLocaleString()}
            </div>

            <div className="font-normal italic text-[#959fa8] text-sm tracking-[-0.40px] leading-normal">
              Projects On-Hold
            </div>
          </div>
        </button>
      </div>
    </div>
  );
};

export default DashboardReopenRow;
